import React from "react";
import classes from "./Divider.module.css";

const Spacer = ({ height, mobile = false }) => {
  return (
    <div
      className={mobile ? classes.mobileNone : classes.spacer}
      style={{ height: height + "px" }}
    ></div>
  );
};

export default Spacer;
